<script>
export default {
  props: {
    item: {
      type: Object,
    },
    link: {
      type: String,
    },
  },
  methods: {
    handlerDelete(item) {
      this.$emit('handlerDelete',item);
    },
  },
};
</script>
<template>
  <Card>
    <CardTitle>
      {{item.label}}
      <BtnDanger
        slot="btn"
        @click="handlerDelete(item)"
        v-if="$core.permission.has(362)"
      >
        <i class="el-icon-delete"></i>
        Удалить
      </BtnDanger>
      <router-link
        v-if="$core.permission.has(361)"
        slot="btn"
        :to="`/admin/tour/${item.value}`"
        style="margin-left: 16px;"
      >
        <BtnPrimary>
          <i class="el-icon-edit"></i>
          Редактировать
        </BtnPrimary>
      </router-link>
    </CardTitle>
    <RowSpan>
      <ColSpan span="4">
        <FStatic label="Тип тура">
          {{item.tourTypeName}}
        </FStatic>
        <FStatic label="Юр. лицо">
          {{item.ownerLegalName}}
        </FStatic>
      </ColSpan>
      <ColSpan span="4">
        <FStatic label="Отправление">
          {{item.departureCityName}}
        </FStatic>
        <FStatic label="Прибытия">
          {{item.countryName}} -
          {{item.cityName}}
        </FStatic>
      </ColSpan>
      <ColSpan span="4">
        <FStatic label="Продолжительность">
          {{item.duration || 0}}д.
        </FStatic>
        <FStatic label="Квота мест">
          {{item.defaultPeopleQuota}}
        </FStatic>
      </ColSpan>
    </RowSpan>
  </Card>
</template>
<style lang="scss">
  .p-t-c-li {

    &__group {
      margin-bottom: 8px;
      font-size: 16px;

      span {
        display: inline-block;
        width: 150px;
        font-weight: 700;
      }
    }

    &__preview {
      width: 180px;
      height: 180px;
      margin-right: 16px;
      flex-shrink: 0;
      line-height: 0;
      display: flex;
      align-items: center;
      justify-content: center;

      img {
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
    }

    &__dates {
      margin-top: 8px;
      a {
        margin-right: 8px;
      }
    }
  }

  @media (max-width: 500px) {
    .p-t-c-li {
      .card-title {
        display: block;
      }

      .card-title__name {
        height: auto;
      }

      .card-body--flex {
        display: block;
      }

      .card-title__btn {
        justify-content: flex-end;
        margin: 0;
        padding-top: 8px;
      }
    }
    .p-t-c-li__preview {
      width: 100%;
      margin: 0 0 16px 0;
    }
  }
</style>
